import { types } from "@halter-corp/halter-common-login";

export const awsAuthConfig = {
  region: process.env.REACT_APP_AWS_REGION,
  userPoolId: process.env.REACT_APP_AWS_USER_POOL_ID,
  userPoolWebClientId: process.env.REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID,
};

export const awsOAuthConfig = {
  region: process.env.REACT_APP_AWS_REGION,
  userPoolId: process.env.REACT_APP_AWS_USER_POOL_ID,
  userPoolWebClientId: process.env.REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID,
  oauth: {
    domain: process.env.REACT_APP_OAUTH_DOMAIN,
    scope: process.env.REACT_APP_OAUTH_SCOPE?.split(',').map(item => item.trim()),
    redirectSignIn: process.env.REACT_APP_OAUTH_REDIRECT_SIGN_IN,
    redirectSignOut: process.env.REACT_APP_OAUTH_REDIRECT_SIGN_OUT,
    responseType: process.env.REACT_APP_OAUTH_RESPONSE_TYPE,
  },
};

export const oauthEnabled =
  (process.env.REACT_APP_OAUTH_ENABLED === "true") || false;

export const environment =
  (process.env.REACT_APP_ENVIRONMENT as types.Environment) || undefined;

export const defaultReferral = process.env.REACT_APP_DEFAULT_REFERRAL || "";
